import { useTranslation } from "react-i18next";
import { IoCopyOutline } from "react-icons/io5";
import { RiFileExcel2Line } from "react-icons/ri";

interface Props {
  toggleExportModal: boolean;
  setToggleExportModal: React.Dispatch<React.SetStateAction<boolean>>;
  setToggleExportOptions: React.Dispatch<React.SetStateAction<boolean>>;
  toggleExportOptions: boolean;
  exportLoading: boolean;
  exportMode: string;
  setExportMode: React.Dispatch<
    React.SetStateAction<"all" | "select" | "view">
  >;
  report: any;
  exportExceel: any;
  versionId: any;
}

export default function ExportModal({
  toggleExportModal,
  setToggleExportModal,
  setToggleExportOptions,
  toggleExportOptions,
  exportLoading,
  exportMode,
  setExportMode,
  exportExceel,
  versionId,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {toggleExportModal && (
        <div
          className="fixed top-0 left-0 z-[100] w-full h-full bg-black bg-opacity-50 flex justify-center items-center"
          onClick={() => !exportLoading && setToggleExportModal(false)}
        >
          <div
            className="bg-white p-14 rounded-lg min-w-[25rem] max-w-full flex justify-center items-center gap-12"
            onClick={(e) => e.stopPropagation()}
          >
            {!exportLoading && (
              <>
                <div
                  role="button"
                  className="flex flex-col justify-center items-center gap-2 text-3xl font-bold text-text"
                  // onClick={exportCSV}
                  onClick={() => {
                    setToggleExportOptions(true);
                  }}
                >
                  <RiFileExcel2Line className="text-5xl opacity-75" />
                  {t("xlsx")}
                </div>
                {/* <div
                  role="button"
                  className="flex flex-col justify-center items-center gap-2 text-3xl font-bold text-text cursor-pointer"
                  // onClick={handleCopy}
                >
                  <IoCopyOutline className="text-5xl opacity-75" />
                  {t("copy")}
                </div> */}
              </>
            )}
            {exportLoading && (
              <div className="flex flex-col justify-center items-center gap-2 text-2xl font-bold text-text">
                <div className="animate-spin rounded-full h-20 w-20 border-b-4 border-gray-900"></div>
                {t("loading")}
              </div>
            )}
          </div>
        </div>
      )}

      {toggleExportOptions && (
        <>
          <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[101] flex flex-col justify-center items-center bg-white p-14 py-28 rounded-lg min-w-[25rem] max-w-full gap-12">
            {exportLoading ? (
              <div className="flex flex-col justify-center items-center gap-2 text-2xl font-bold text-text">
                <div className="animate-spin rounded-full h-20 w-20 border-b-4 border-gray-900"></div>
                {t("loading")}
              </div>
            ) : (
              <>
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => setExportMode("all")}
                    className={`main_btn ${exportMode === "all" ? "active" : ""}`}
                  >
                    All
                  </button>
                  <button
                    onClick={() => setExportMode("select")}
                    className={`main_btn ${exportMode === "select" ? "active" : ""}`}
                  >
                    Select
                  </button>
                  <button
                    onClick={() => setExportMode("view")}
                    className={`main_btn ${exportMode === "view" ? "active" : ""}`}
                  >
                    View
                  </button>
                </div>
                <div className="flex items-center gap-x-3">
                  <button
                    className={`self-start main_btn cursor-pointer capitalize`}
                    onClick={() => exportExceel(versionId)}
                  >
                    {t("export")}
                  </button>
                  <button
                    className={`self-start main_btn cursor-pointer`}
                    onClick={() => exportExceel(versionId, true)}
                  >
                    {t("export_images")}
                  </button>
                </div>
              </>
            )}
          </div>
          <div
            onClick={(e) => {
              e.stopPropagation();
              if (!exportLoading) {
                setToggleExportModal(false);
                setToggleExportOptions(false);
              }
            }}
            className="fixed top-0 left-0 z-[100] w-full h-full bg-black bg-opacity-50 flex justify-center items-center"
          />
        </>
      )}
    </>
  );
}
